<template>
	<v-container style="overflow: hidden;">
		<iframe
			:src="
				`https://metabase-new.sharechat.com/public/dashboard/8e4c5b75-780b-401f-93ea-13adbb7ee29b?tsm_id=${retailerId}&date=${date}`
			"
			title="Aggregated Sales"
			class="iframe"
		></iframe>
	</v-container>
</template>

<script>
export default {
	name: "Sales",
	props: {
		date: {
			type: String
		},
		retailerId: {
			type: String,
			default: ""
		}
	}
};
</script>
<style scoped lang="scss">
.iframe {
	position: relative;
	width: 100%;
	height: 100%;
	min-height: 600px;
	top: -9.5em;
}
@media screen and (min-width: 600px) {
	.iframe {
		position: relative;
		width: 100%;
		height: 100%;
		min-height: 800px;
		top: -9.5em;
	}
}
</style>
